import type { ReactNode } from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
interface DrawerFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  children: ReactNode;
}

// A labelled slot in the edit drawer: field label, its control, and any
// validation message underneath.
export const DrawerField = ({
  label,
  required,
  error,
  children,
}: DrawerFieldProps) => (
  <Stack gap="xs" fullWidth>
    <Typography variant="subtitleW3" textColor="interactive">
      {label}
      {required && <span className="ml-1 text-destructive">*</span>}
    </Typography>
    {children}
    {error && (
      <Typography variant="bodyW3" className="text-negative-text">
        {error}
      </Typography>
    )}
  </Stack>
);
